
import axios from 'axios'

import router from '@/router/index';


/*headers: {
  'Content-Type': 'application/json'
http://localhost:8001/    local DOCKER
  http://localhost:8000/  local Normal.
  http://185.254.204.241:8001/    production VPS

  https://teczoa.com/    //production ultimate


}*/

export const http = axios.create({
  baseURL: 'https://teczoa.com/',
  'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
});

http.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  config.headers.Authorization = token ? `Bearer ${token}` : '';

  return config;
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log('Error en la peticion, se necesita login', error);

  if (error.response.status === 401)
    router.push('/login');

  if (error.response.status === 500) {
    router.push('/login');
  }

  /*if (error.response.status === 422) {
      // Mostrar el primer mensaje de error si existe
      const errors = error.response.data.errors;
      const firstMessage = Object.values(errors)[0]?.[0];

      if (firstMessage) {
        console.log(firstMessage);
      }
    }*/

 

  else {
    return Promise.reject(error);
  }
});
